export default "__VITE_ASSET__BhC36UDG__"